module.exports = __webpack_public_path__ + "img/layout-blue.e94b2e02.svg";